import { Button, Modal } from "antd";
import parse from "html-react-parser";
import React from "react";
import correctImage from "../../../assets/images/answer-modal-title-correct.png";
import wrongImage from "../../../assets/images/answer-modal-title-wrong.png";
import { Constants } from "../../../core/helpers/constants";
import FireRemoteService from "../../../core/services/fire-remote";
import AppStore from "../../../Store";
import "./congratulations-modal.scss";
import PrizeInfo from "../answer-modal/prize-info/prize-info";

interface IProps {
  appStore: AppStore;
  isVisible: boolean;
  isCorrect: boolean;
  callbackGetNewQuestion: () => void;
}

const CongratulationsModal = (props: IProps) => {
  const getTitleKey = () => {
    return props.isCorrect 
      ? FireRemoteService.correct_congratulations_popup_title 
      : FireRemoteService.wrong_congratulations_popup_title;
  };

  const getInfoKey = () => {
    return props.isCorrect 
      ? FireRemoteService.correct_congratulations_popup_info 
      : FireRemoteService.wrong_congratulations_popup_info;
  };


  const getButtonKey = () => {
    return props.isCorrect 
      ? FireRemoteService.correct_congratulations_popup_button 
      : FireRemoteService.wrong_congratulations_popup_button;
  };

  const getImageSrc = () => {
    return props.isCorrect ? correctImage : wrongImage;
  };

  const getPrizePoints = () => {
    return props.isCorrect 
      ? FireRemoteService.correct_congratulations_popup_fb
      : FireRemoteService.wrong_congratulations_popup_fb;
  };

  const getPrizeTitle = () => {
    return props.isCorrect 
      ? FireRemoteService.correct_congratulations_popup_kazandin
      : FireRemoteService.wrong_congratulations_popup_kazandin;
  };



  return (
    <Modal
      className="congratulations-modal"
      maskStyle={{ backdropFilter: "blur(8px)" }}
      visible={props.isVisible}
      centered
      closable={false}
      footer={false}
      onCancel={props.callbackGetNewQuestion}
    >
      <div id="congratulations-modal-body" className={props.isCorrect ? "correct" : "wrong"}>
        <div className="title-wrapper">
          <img className="icon" src={getImageSrc()} alt={props.isCorrect ? "correct" : "wrong"} />
          <div className="text">
            {parse(
              FireRemoteService.getStringValue(getTitleKey())
            )}
          </div>
        </div>

        <PrizeInfo
          points={FireRemoteService.getStringValue(getPrizePoints())}
          title={FireRemoteService.getStringValue(getPrizeTitle())}
        />

        <div className="note">
          {parse(
            FireRemoteService.getStringValue(getInfoKey())
          )}
        </div>

        <div className="button-container">
          <Button
            className="modal-button primary"
            onClick={() => props.callbackGetNewQuestion()}
          >
            {parse(
              FireRemoteService.getStringValue(getButtonKey())
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CongratulationsModal;

